import React, { useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { history } from '../../_redux/_store/history'
import FooterPagination from '../_footerpagination/FooterPagination'
import { withStyles, makeStyles } from '@material-ui/core/styles'
import Table from '@material-ui/core/Table'
import TableBody from '@material-ui/core/TableBody'
import TableCell from '@material-ui/core/TableCell'
import TableHead from '@material-ui/core/TableHead'
import TableContainer from '@material-ui/core/TableContainer'
import TableRow from '@material-ui/core/TableRow'
import Grid from '@material-ui/core/Grid'
import Typography from '@material-ui/core/Typography'
import Button from '@material-ui/core/Button'
import MuiAccordion from '@material-ui/core/Accordion'
import MuiAccordionSummary from '@material-ui/core/AccordionSummary'
import MuiAccordionDetails from '@material-ui/core/AccordionDetails'
import queryString from 'query-string'
import {
  fetchScopeList,
  deleteScopedFinding,
} from '../../_redux/_actions/scopeListAction'
import EditIcon from '@material-ui/icons/Edit'
import DeleteIcon from '@material-ui/icons/Delete'
import EditScopeList from '../selectScope/EditScopeList.jsx'
import useDebounce from '../../utilities/useDebounce'
import SkeletonTableList from '../skeleton/SkeletonTableList.jsx'

const StyledTableCell = withStyles((theme) => ({
  head: {
    color: 'white',
  },
  body: {
    fontSize: 14,
  },
}))(TableCell)

const useStyles = makeStyles(() => ({
  Button: {
    width: '120px',
    marginRight: '20px',
    '&:hover': {
      background: '#52A1C2',
    },
  },
  helpIcon: {
    marginBottom: '10px',
    marginLeft: '0.5px',
    width: '20px',
  },
  accordionButton: {
    '&:hover': {
      backgroundColor: 'white',
    },
    containerPaper: {
      height: '70%',
      padding: '30px',
      opacity: '1',
    },
    deleteFindingRuleTable: {
      marginTop: '2em',
    },
  },
  searchField: {
    marginTop: '-0.75em',
    marginRight: '20px',
  },
  containerPaper: {
    padding: '50px',
    height: '100%',
  },
  Pagination: {
    marginBottom: '50px',
    marginRight: '30px',
    marginTop: '30px',
  },
}))

const Accordion = withStyles({
  root: {
    boxShadow: 'none',
    '&:not(:last-child)': {
      borderBottom: 0,
    },
    '&:before': {
      display: 'none',
    },
  },
  expanded: {},
})(MuiAccordion)

const AccordionSummary = withStyles({
  root: {
    marginBottom: -1,
    padding: 0,
  },
})(MuiAccordionSummary)

const AccordionDetails = withStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
  },
}))(MuiAccordionDetails)

export default function ScopeList({ scopeDataString }) {
  const classes = useStyles()
  const scopeCollectionList = useSelector((state) => state.scopeList)
  const [currentPage, setcurrentPage] = useState(1)
  const [page, setPage] = useState(1)
  const [rulesPerPage] = useState(8)
  const queryValues = queryString.parse(history.location.search)
  const {machine_type,hmi_type} = queryValues;
  const findingRuleId = queryValues.findingRuleId
  const [scopeCollection, setScopeCollection] = useState('')
  const [mainScopeCollection, setMainScopeCollection] = useState('')
  const [editScope, setEditScope] = useState(false)
  const [dataToEdit, setDataToEdit] = useState('')
  const [scopeNoteText, setScopeNoteText] = useState('')
  const dispatch = useDispatch()
  const debounce = useDebounce()
  
  useEffect(() => {
    dispatch(fetchScopeList(findingRuleId, null,machine_type,hmi_type))
  }, [])

  useEffect(() => {
    if (scopeCollectionList.scopeList) {
      setMainScopeCollection(scopeCollectionList.scopeList)
      setScopeCollection(scopeCollectionList.scopeList)
    }
    if(scopeDataString){
        filterScopes(scopeDataString)
    }
  }, [scopeCollectionList.scopeList])

  const filterScopes = (scopeDataString) =>{
    var scopeDataSplit = scopeDataString.split(":")
    if (scopeDataString.length > 0 && scopeCollectionList.scopeList.length > 0) {
      var scope_List = scopeCollectionList.scopeList.filter((item) => {
        var itemSplit = item.scope.split(":")
        let count = 0
        for (let i = 0; i< scopeDataSplit.length; i++)
        {
          if(scopeDataSplit[i] === itemSplit[i+1]){
            count++;
          }
        }
        if(count === scopeDataSplit.length){
          return item.scope
        }
      })
      setScopeCollection([...scope_List])
    }
    else{
      setScopeCollection(mainScopeCollection)
    }
  }

  useEffect(() => {
    filterScopes(scopeDataString)
  }, [scopeDataString])

  const paginate = (pageNumber) => {
    setcurrentPage(pageNumber)
  }

  const handleChange = (event, value) => {
    setPage(value)
    paginate(value)
  }

  //Edit Scope
  const handleEdit = (data) => {
    setEditScope(true)
    setDataToEdit(data)
    setScopeNoteText(data.scope)
  }

  const handleClose = () => {
    setEditScope(false)
    debounce(() => {
      dispatch(fetchScopeList(findingRuleId, null,machine_type,hmi_type))
    })
  }

  //Delete Scope
  const handleDelete = (data) => {
    dispatch(deleteScopedFinding(findingRuleId, data.scope,machine_type,hmi_type))

    debounce(() => {
      dispatch(fetchScopeList(findingRuleId, null,machine_type,hmi_type))
    })
  }

  //go to scoped finding config
  const handleConfirm = (row) => {
    history.push(
      `/rules/select_finding_rule/select_scope/scoped_finding_rule_configuration?machine_type=${machine_type}&hmi_type=${hmi_type}&findingRuleId=${findingRuleId}&scope=${row.scope}`
    )
  }

  return (
    <>
      {scopeCollection ? (
        <TableContainer>
          <Table className={classes.table} aria-label='custom pagination table'>
            <TableHead>
              <TableRow style={{ backgroundColor: 'grey' }}>
                <StyledTableCell align='left'>
                  <Typography style={{ color: 'white' }}>Scope</Typography>
                </StyledTableCell>
                <StyledTableCell align='left'>
                  <Typography style={{ color: 'white' }}>Note Text</Typography>
                </StyledTableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {scopeCollectionList.loading && <SkeletonTableList count={2}/>}
              {!scopeCollectionList.loading && scopeCollection ?
                scopeCollection.map((row, id) => (
                  <TableRow style={{ height: 10 }} key={`scope${id}`}>
                    <TableCell align='left'>
                      {' '}
                      <Accordion square elevation={0}>
                        <AccordionSummary
                          aria-controls='panel1a-content'
                          id='panel1'
                        >
                          {row.scope}
                        </AccordionSummary>
                        <AccordionDetails>
                          <Grid
                            container
                            direction='row'
                            style={{ marginLeft: '0.5em' }}
                          >
                            <Grid item>
                              <Button
                                style={{ backgroundColor: '#52A1C2' }}
                                onClick={() => handleConfirm(row)}
                              >
                                Confirm
                              </Button>
                            </Grid>
                            <Grid style={{ marginLeft: '0.5em' }}>
                              <Button
                                className={classes.accordionButton}
                                onClick={() => handleEdit(row)}
                              >
                                <EditIcon style={{ fill: 'grey' }} />
                              </Button>
                            </Grid>
                            <Grid item style={{ marginLeft: '0.5em' }}>
                              <Button
                                className={classes.accordionButton}
                                onClick={() => handleDelete(row)}
                              >
                                <DeleteIcon style={{ fill: 'grey' }} />
                              </Button>
                            </Grid>
                          </Grid>
                        </AccordionDetails>
                      </Accordion>
                    </TableCell>
                    <TableCell align='left'>{row.note_text}</TableCell>
                  </TableRow>
                )):null}
                {
                  !scopeCollectionList.loading && scopeCollection.length==0?<TableRow
                  style={{ height: 10 }}
                >
                  <TableCell colSpan={5}>
                   No data found
                  </TableCell>
                </TableRow>:null
                }
            </TableBody>
          </Table>

          <FooterPagination
            page={page}
            handleChange={handleChange}
            rulesPerPage={rulesPerPage}
            totalRules={scopeCollection.length}
            paginate={paginate}
          />
        </TableContainer>
      ) : null}
      {/* </Grid> */}
      {/* </Grid> */}

      {/* Rendering Edit Finding Rule Component */}
      {editScope && (
        <EditScopeList
          open={editScope}
          dataToEdit={dataToEdit}
          findingRuleID={findingRuleId}
          scopeDataString={scopeNoteText}
          onClose={handleClose}
        />
      )}
    </>
  )
}
